
import {
  KMFC_BANK_REFERENCE_DATA_GET_VALUE,
  KMFC_BRANCH_CODES_REFERENCE_DATA_GET_VALUE,
  setBankReferenceData,
  setBranchCodeReferenceData,
  setBranchCodesApiStatus,
} from "../../../actions/kaMetlhaFuneralClaim/referenceData";
import axios from "axios";
import { API_CALL_STATUS } from "../../../reducers/status";

export const referenceDataService = (store, next, action) => {
  const result = next(action);
  

  if(action.type===KMFC_BANK_REFERENCE_DATA_GET_VALUE){
    (async () => {
      const bankReferenceData = await fetchBankReferenceData();
      if (bankReferenceData) {
        store.dispatch(
          setBankReferenceData(bankReferenceData.data)
        );

      }
    })();
  }

  if(action.type===KMFC_BRANCH_CODES_REFERENCE_DATA_GET_VALUE){
    (async () => {
       store.dispatch(setBranchCodesApiStatus({status:API_CALL_STATUS.PENDING,apiFor:'branchCode'}))
      const branchCodesReferenceData = await fetchBranchCodesReferenceData(action.value);
      if (branchCodesReferenceData) {
        store.dispatch(
          setBranchCodeReferenceData(branchCodesReferenceData.data)
        );
        store.dispatch(setBranchCodesApiStatus({status:API_CALL_STATUS.SUCCESS,apiFor:'branchCode'}))
      }else{
        store.dispatch(setBranchCodesApiStatus({status:API_CALL_STATUS.FAILURE,apiFor:'branchCode'}))
      }
    })();
}

  return result;
};




const fetchBankReferenceData = async () => {
  try {
    const response = await axios.get('/om-api/ka-metlha-funeral/banksBw', {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    });
      return response;
  } catch (error) {
      return null;
  }
};

const fetchBranchCodesReferenceData = async (bankCode) => {
  try {
      const response = await axios({
          url: `/om-api/ka-metlha-funeral/bankBranchBw/${bankCode}`,
          method: 'get',
          headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              'Access-Control-Allow-Origin': 'null',
          },
      });
      return response;
  } catch (error) {
      return null;
  }
};
